import React from 'react';
import ReactDOM from 'react-dom';
import PageRoute from './containers/Route.container';
import './style/index.css';

ReactDOM.render(
  <React.StrictMode>
    <PageRoute />
  </React.StrictMode>,
  document.getElementById('root'),
);
